import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change:
 *  - No hash → scroll to top (0,0)
 *  - Hash present → scroll to element with that id
 * Uses Lenis if available, else window.scrollTo.
 */
export default function ScrollManager() {
  const { pathname, hash, key, search } = useLocation();
  const prevPath = useRef(pathname);
  const prevSearch = useRef(search);

  useEffect(() => {
    const lenis = typeof window !== "undefined" ? window.__lenis : null;
    const pathChanged = prevPath.current !== pathname;
    const searchChanged = prevSearch.current !== search;
    prevPath.current = pathname;
    prevSearch.current = search;

    // Only the query string changed (e.g. /news?cat=…) → leave scroll position alone
    if (!hash && !pathChanged && searchChanged) return;

    if (hash) {
      const id = hash.replace(/^#/, "");
      // Defer so target has mounted after route change
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          if (lenis) lenis.scrollTo(el, { offset: -40 });
          else el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          if (lenis) lenis.scrollTo(0, { immediate: true });
          else window.scrollTo(0, 0);
        }
      }, 50);
      return () => clearTimeout(t);
    }

    // no hash → top
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash, key, search]);

  return null;
}
